import * as yup from 'yup';
import { checkDateIsLower, checkDateIsStrictlyLower } from 'utils/date';

export const sortingCenterContractEditFormSchema = (
  pt: any,
  closureDate: Date,
  canEditDateOrWeight: boolean,
  minDateContractEdit: Date | null,
): yup.AnyObjectSchema =>
  yup.object().shape({
    estimatedReceptionWeight: yup
      .number()
      .transform(value => (isNaN(value) ? undefined : value))
      .required(pt('validation.weight.required'))
      .typeError(pt('validation.weight.invalid'))
      .min(0, pt('validation.weight.invalid')),
    //.moreThan(0, pt('validation.weight.invalid')),
    startDate: yup
      .date()
      .typeError(pt('validation.startDate.invalid'))
      .nullable()
      .required(pt('validation.startDate.required'))
      .test(
        'alreadyClosedMonth',
        pt('validation.startDate.alreadyClosedMonth'),
        (value, _) => !value || checkDateIsStrictlyLower(closureDate, value) || !canEditDateOrWeight,
      )
      .when('endDate', {
        is: (endDate: Date | null) => !!endDate,
        then: yup
          .date()
          .typeError(pt('validation.startDate.invalid'))
          .nullable()
          .required(pt('validation.startDate.required'))
          .test('startDateValidation', pt('validation.startDate.greaterThanEndDate'), (value, context) => {
            const endDate = context.parent.endDate;
            return checkDateIsStrictlyLower(value, endDate);
          }),
      }),
    endDate: yup
      .date()
      .typeError(pt('validation.endDate.invalid'))
      .nullable()
      .required(pt('validation.endDate.required'))
      .test('endDateValidation', pt('validation.endDate.lesserThanStartDate'), (value, context) => {
        const startDate = context.parent.startDate;
        return !startDate || '' === startDate || checkDateIsStrictlyLower(startDate, value);
      })
      .test('alreadyClosedMonthFinalDate', pt('validation.endDate.alreadyClosedMonth'), (value, _) => {
        return checkDateIsStrictlyLower(closureDate, value);
      })
      .test(
        'lesserThanReceptionOrCharacterization',
        pt('validation.endDate.lesserThanReceptionOrCharacterization'),
        (value, _) => {
          if (minDateContractEdit) {
            return checkDateIsLower(minDateContractEdit, value);
          }
          return true;
        },
      ),
    characterizationNumber: yup
      .number()
      .transform(value => (isNaN(value) ? null : value))
      .nullable()
      .typeError(pt('validation.characterizationNumber.invalid'))
      .moreThan(0, pt('validation.characterizationNumber.invalid'))
      .required(pt('validation.characterizationNumber.required')),
    //client: yup.string().required(pt('validation.requiredClient')),
    stream: yup.string().required(pt('validation.requiredStream')),
  });
